const ChevronDown = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-chevron-down"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-chevron-down"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M18.71,8.21a1,1,0,0,0-1.42,0l-4.58,4.58a1,1,0,0,1-1.42,0L6.71,8.21a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.59,4.59a3,3,0,0,0,4.24,0l4.59-4.59A1,1,0,0,0,18.71,8.21Z" />
    </svg>
  );
};

export default ChevronDown;
